import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    setLoading(true);
    try {
      // Hit /workspace first to ensure migration has run, then /auth/me
      try { await api.get("/workspace"); } catch {}
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const loginWithEmail = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("token", data.token);
    try { await api.get("/workspace"); } catch {}
    const { data: me } = await api.get("/auth/me");
    setUser(me);
    return me;
  };

  const registerEmail = async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    localStorage.setItem("token", data.token);
    try { await api.get("/workspace"); } catch {}
    const { data: me } = await api.get("/auth/me");
    setUser(me);
    return me;
  };

  const logout = async () => {
    // Tear down local state FIRST so UI flips instantly even if the network is slow.
    try { localStorage.removeItem("token"); } catch {}
    try { sessionStorage.clear(); } catch {}
    setUser(null);
    // Best-effort server-side session invalidation (don't block the redirect on it).
    api.post("/auth/logout").catch(() => {});
    // Force a hard reload so all React state + caches clear.
    window.location.replace("/login");
  };

  const value = { user, loading, loginWithEmail, registerEmail, logout, setUser, checkAuth };
  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
